import { toast, ToastOptions } from 'react-toastify';

const defaultOptions: ToastOptions<unknown> = {
  position: 'top-center',
  autoClose: 5000,
};

export const toastSuccess = (message: string, options?: ToastOptions<unknown>) => {
  toast(message, {
    ...defaultOptions,
    toastId: 'success',
    type: 'success',
    ...options,
  });
};

export const toastWarning = (message: string, options?: ToastOptions<unknown>) => {
  toast(message, {
    ...defaultOptions,
    toastId: 'warning',
    type: 'warning',
    ...options,
  });
};

export const toastError = (message: string, options?: ToastOptions<unknown>) => {
  toast(message, {
    ...defaultOptions,
    toastId: 'error',
    type: 'warning',
    ...options,
  });
};
